<template>
  <div id="jobForm">
    <div class="common_top_wrap">
      <div class="common_tit">프로그램 등록</div>
    </div>
    <div class="common_form_wrap">
      <div class="common_form_item col-2">
        <div class="common_form_label">기업명</div>
        <div class="common_form_input">
          <input type="text" v-model="companyName" placeholder="기업명을 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">대표자명</div>
        <div class="common_form_input">
          <input type="text" v-model="ceoName" placeholder="대표자명을 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">근로자수</div>
        <div class="common_form_input">
          <input type="text" v-model="employeeNum" placeholder="근로자수를 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">업종</div>
        <div class="common_form_input">
          <input type="text" v-model="businessType" placeholder="업종을 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">사업내용</div>
        <div class="common_form_input">
          <input type="text" v-model="businessDesc" placeholder="사업내용을 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">소재지</div>
        <div class="common_form_input">
          <input type="text" v-model="locationName" placeholder="소재지를 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-6">
        <div class="common_form_label">홈페이지</div>
        <div class="common_form_input">
          <input type="text" v-model="homepage" placeholder="홈페이지를 입력하세요"/>
        </div>
      </div>
    </div>
    <div class="common_form_wrap border_top">
      <div class="common_form_item col-6">
        <div class="common_form_label">채용 공고명</div>
        <div class="common_form_input">
          <input type="text" v-model="subject" placeholder="채용 공고명을 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">채용 기간</div>
        <div class="common_form_input datepicker_wrap">
          <vue-datepicker-local v-model="dateRange" :local="ko" placeholder="채용 기간을 선택하세요"/>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">최종 학력</div>
        <div class="common_form_input">
          <select v-model="eduType">
            <option value="">선택</option>
            <option value="EDU01">초등학교</option>
            <option value="EDU02">중학교</option>
            <option value="EDU03">고등학교</option>
            <option value="EDU04">대학교(2, 3년제)</option>
            <option value="EDU05">대학교(4년제)</option>
            <option value="EDU06">대학원(석사)</option>
            <option value="EDU07">대학원(박사)</option>
            <option value="EDU08">학력무관</option>
            <option value="EDU09">기타</option>
          </select>
        </div>
      </div>
      <div class="common_form_item col-2">
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">고용형태</div>
        <div class="common_form_input">
          <select v-model="employeeType">
            <option value="">선택</option>
            <option value="EMP01">정규직</option>
            <option value="EMP02">계약직</option>
            <option value="EMP03">파견직</option>
            <option value="EMP04">시간제</option>
            <option value="EMP05">촉탁직</option>
            <option value="EMP06">기타</option>
          </select>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">급여</div>
        <div class="common_form_input type_salary">
          <select v-model="salaryType">
            <option value="">선택</option>
            <option value="SAL01">월급</option>
            <option value="SAL02">연봉</option>
            <option value="SAL03">시급</option>
          </select>
          <input type="text" v-model="salary" placeholder="급여를 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">모집인원</div>
        <div class="common_form_input">
          <input type="text" v-model="recruitNum" placeholder="모집인원을 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-3">
        <div class="common_form_label">모집직무</div>
        <div class="common_form_input">
          <input type="text" v-model="recruitWork" placeholder="모집직무를 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-3">
        <div class="common_form_label">모집부분 및 담당업무</div>
        <div class="common_form_input">
          <input type="text" v-model="respWork" placeholder="모집부분 및 담당업무를 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-6">
        <div class="common_form_label">우대사항/자격요건</div>
        <div class="common_form_input">
          <input type="text" v-model="premiumRequirement" placeholder="우대사항/자격요건을 입력하세요"/>
        </div>
      </div>
    </div>
    <div class="common_form_wrap border_top">
      <div class="common_form_item col-2">
        <div class="common_form_label">경력유무</div>
        <div class="common_form_input">
          <select v-model="careerType">
            <option value="">선택</option>
            <option value="CAR01">경력직</option>
            <option value="CAR02">신입</option>
            <option value="CAR03">경력무관</option>
          </select>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">근무시간</div>
        <div class="common_form_input type_salary">
          <select v-model="workStart">
            <option value="">선택</option>
            <option :key="'start_' + item.codeValue" v-for="item in hourMinuteList" :value="item.codeValue">{{item.codeName}}</option>
          </select>
          <select v-model="workEnd">
            <option value="">선택</option>
            <option :key="'start_' + item.codeValue" v-for="item in hourMinuteList" :value="item.codeValue">{{item.codeName}}</option>
          </select>
        </div>
      </div>
      <div class="common_form_item col-2">
        <div class="common_form_label">근무지 상세</div>
        <div class="common_form_input">
          <input type="text" v-model="locationDetail" placeholder="근무지 상세를 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-6">
        <div class="common_form_label">복리후생</div>
        <div class="common_form_input type_checkbox">
          <div>
            <input type="checkbox" id="benefit1" v-model="benefit1" @click.stop="toggleCheckbox('benefit1')"/>
            <label for="benefit1">퇴직금</label>
          </div>
          <div>
            <input type="checkbox" id="benefit2" v-model="benefit2" @click.stop="toggleCheckbox('benefit2')"/>
            <label for="benefit2">식사제공</label>
          </div>
          <div>
            <input type="checkbox" id="benefit3" v-model="benefit3" @click.stop="toggleCheckbox('benefit3')"/>
            <label for="benefit3">퇴직연금</label>
          </div>
          <div>
            <input type="checkbox" id="benefit4" v-model="benefit4" @click.stop="toggleCheckbox('benefit4')"/>
            <label for="benefit4">상여금</label>
          </div>
          <div>
            <input type="checkbox" id="benefit5" v-model="benefit5" @click.stop="toggleCheckbox('benefit5')"/>
            <label for="benefit5">4대보험</label>
          </div>
        </div>
      </div>
    </div>
    <div class="common_bottom_wrap">
      <div class="btn_grey" @click="moveList">목록</div>
      <div class="btn_bottom" @click="saveJob">{{jobPid != null && jobPid !== '' ? '수정' : '등록'}}</div>
    </div>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import common from '../../script/common'
import job from '../../script/job'

export default {
  components: {VueDatepickerLocal},
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      // Search
      searchParams: {},
      // Common Data
      hourMinuteList: common.getHourMinuteList(),
      // Data
      originData: {},
      jobPid: null,
      companyName: '', // 채용 회사명
      companyLogo: '', // 회사 로고. ci
      ceoName: '', // 대표자명
      employeeNum: '', // 근로자수
      businessType: '', // 업종
      businessDesc: '', // 사업내용
      locationName: '', // 소재지
      homepage: '', // 홈페이지
      subject: '', // 채용 공고명
      recruitStart: '', // 모집시작일
      recruitEnd: '', // 모집종료일
      dateRange: [],
      employeeType: '', // 고용형태
      salaryType: '', // 급여방식
      salary: '', // 급여
      recruitNum: '', // 모집인원
      recruitWork: '', // 모집직무
      respWork: '',
      premiumRequirement: '', // 우대사항/자격요건
      careerType: '', // 경력유무
      eduType: '', // 학력유무
      workStart: '', // 근무시작시간
      workEnd: '', // 근무종료시간
      locationDetail: '', // 근무지 상세
      benefits: '', // 복리후생
      benefit1: false,
      benefit2: false,
      benefit3: false,
      benefit4: false,
      benefit5: false
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        if (this.$route.params != null) {
          if (this.$route.params.searchParams != null) {
            this.searchParams = this.$route.params.searchParams
          }
          if (this.$route.params.data != null && this.$route.params.data.jobPid != null) {
            this.setJob(this.$route.params.data)
          }
        }
      } else {
        common.amsAlert('general', '세션이 만료되었습니다.\n다시 로그인하세요.')
        this.$router.replace('/Job/List')
      }
    })
  },
  watch: {
    employeeNum () {
      this.employeeNum = common.getOnlyNumber(this.employeeNum)
    },
    salary () {
      this.salary = common.getOnlyNumber(this.salary)
    },
    recruitNum () {
      this.recruitNum = common.getOnlyNumber(this.recruitNum)
    }
  },
  methods: {
    setJob (data) {
      console.log(data)
      this.originData = data
      this.jobPid = data.jobPid
      this.companyName = data.companyName
      this.ceoName = data.ceoName
      this.employeeNum = data.employeeNum
      this.businessType = data.businessType
      this.businessDesc = data.businessDesc
      this.locationName = data.locationName
      this.homepage = data.homepage
      this.subject = data.subject
      this.recruitStart = data.recruitStart
      this.recruitEnd = data.recruitEnd
      this.dateRange = [new Date(data.recruitStart), new Date(data.recruitEnd)]
      this.eduType = data.eduType
      this.employeeType = data.employeeType
      this.salaryType = data.salaryType
      this.salary = data.salary
      this.recruitNum = data.recruitNum
      this.recruitWork = data.recruitWork
      this.respWork = data.respWork
      this.premiumRequirement = data.premiumRequirement
      this.careerType = data.careerType
      this.workStart = data.workStart
      this.workEnd = data.workEnd
      this.locationDetail = data.locationDetail
      this.benefits = data.benefits
      this.benefit1 = false
      this.benefit2 = false
      this.benefit3 = false
      this.benefit4 = false
      this.benefit5 = false
      let benefits = data.benefits
      if (benefits != null && benefits.length > 0 && benefits.split(',').length === 5) {
        const item = benefits.split(',')
        this.benefit1 = JSON.parse(item[0])
        this.benefit2 = JSON.parse(item[1])
        this.benefit3 = JSON.parse(item[2])
        this.benefit4 = JSON.parse(item[3])
        this.benefit5 = JSON.parse(item[4])
      }
    },
    toggleCheckbox (type) {
      this[`${type}`] = !this[`${type}`]
    },
    saveJob () {
      if (!common.checkValidateData('string', this.companyName)) {
        common.amsAlert('general', '기업명을 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.ceoName)) {
        common.amsAlert('general', '대표자명을 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.employeeNum)) {
        common.amsAlert('general', '근로자수를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.businessType)) {
        common.amsAlert('general', '업종을 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.businessDesc)) {
        common.amsAlert('general', '사업내용을 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.locationName)) {
        common.amsAlert('general', '소재지를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.homepage)) {
        common.amsAlert('general', '홈페이지를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.subject)) {
        common.amsAlert('general', '채용 공고명을 입력해주세요.')
        return
      }
      if (this.dateRange == null || this.dateRange.length !== 2 ||
          !common.checkValidateData('date', this.dateRange[0]) ||
          !common.checkValidateData('date', this.dateRange[1])) {
        common.amsAlert('general', '채용기간을 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.eduType)) {
        common.amsAlert('general', '최종학력을 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.employeeType)) {
        common.amsAlert('general', '고용형태를 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.salaryType)) {
        common.amsAlert('general', '급여형태를 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.salary)) {
        common.amsAlert('general', '급여를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.recruitNum)) {
        common.amsAlert('general', '모집인원을 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.recruitWork)) {
        common.amsAlert('general', '모집직무를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.respWork)) {
        common.amsAlert('general', '모집부분 및 담당업무를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.premiumRequirement)) {
        common.amsAlert('general', '우대사항/자격요건을 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.careerType)) {
        common.amsAlert('general', '경력유무를 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.workStart)) {
        common.amsAlert('general', '근무 시작시간을 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.workEnd)) {
        common.amsAlert('general', '근무 종료시간을 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.locationDetail)) {
        common.amsAlert('general', '근무지 상세를 입력해주세요.')
        return
      }
      let benefits = []
      benefits.push(this.benefit1)
      benefits.push(this.benefit2)
      benefits.push(this.benefit3)
      benefits.push(this.benefit4)
      benefits.push(this.benefit5)
      let data = {
        // 기업정보
        companyName: this.companyName,
        ceoName: this.ceoName,
        employeeNum: this.employeeNum,
        businessType: this.businessType,
        businessDesc: this.businessDesc,
        locationName: this.locationName,
        homepage: this.homepage,
        // 채용공고
        subject: this.subject,
        recruitStart: common.getFormattedDate(this.dateRange[0]),
        recruitEnd: common.getFormattedDate(this.dateRange[1]),
        eduType: this.eduType,
        employeeType: this.employeeType,
        salaryType: this.salaryType,
        salary: this.salary,
        recruitNum: this.recruitNum,
        recruitWork: this.recruitWork,
        respWork: this.respWork,
        premiumRequirement: this.premiumRequirement,
        careerType: this.careerType,
        workStart: this.workStart,
        workEnd: this.workEnd,
        locationDetail: this.locationDetail,
        benefits: benefits.join(',')
      }
      let method = 'put'
      let checkedData = common.checkChangedData(data, this.originData)
      if (this.jobPid != null) {
        method = 'post'
        if (Object.keys(checkedData).length > 0) {
          checkedData.jobPid = this.originData.jobPid
        } else {
          common.amsAlert('general', '수정된 내용이 없습니다.')
          return
        }
      }
      console.log(method, checkedData)
      job.job(method, checkedData, response => {
        console.log('채용정보 ' + (method === 'put' ? '등록' : '수정'), response)
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '채용정보를 ' + (method === 'put' ? '등록' : '수정') + '했습니다.')
          this.$router.push({
            name: 'JobList',
            params: {
              from: 'FORM',
              searchParams: this.searchParams
            }
          })
        } else {
          common.amsAlert('retry', '채용정보를 ' + (method === 'put' ? '등록' : '수정') + '하지 못했습니다.')
        }
      })
    },
    moveList () {
      this.$router.push({
        name: 'JobList',
        params: {
          searchParams: this.searchParams
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/job/Form.vue